<template>
  <div>
    <!-- Lag navigering her -->
    <navigasjon></navigasjon>
    <router-view></router-view>
    
    <!-- GAMMEL CHALLENGES LØSNING -->
    <!-- <div v-if="this.$store.state.home">
      <my-challenges></my-challenges>
    </div>
    <div v-if="this.$store.state.ranking">
      <my-ranking></my-ranking>
    </div>
    <div v-if="this.$store.state.tournaments">
      <my-tournaments></my-tournaments>
    </div> -->
    <!-- GAMMEL CHALLENGES LØSNING SLUTT -->

    <my-footer></my-footer>
    
  </div>
</template>

<script>
// Firebase her knyttet til gammel challenges løsning
// Your web app's Firebase configuration
// var firebaseConfig = {
//   apiKey: "AIzaSyB4z2Rrh4O9Lp4k7iRdDViGHd_nJw41t5U",
//   authDomain: "biljardapp.firebaseapp.com",
//   databaseURL: "https://biljardapp.firebaseio.com",
//   projectId: "biljardapp",
//   storageBucket: "biljardapp.appspot.com",
//   messagingSenderId: "369715482817",
//   appId: "1:369715482817:web:0020aee677e733c1728440"
// };

// // Initialize Firebase
// Firebase.initializeApp(firebaseConfig);
// import Firebase from 'firebase'
// const db = Firebase.firestore();

import moment from 'moment' 
//import axios from 'axios'
moment.locale('nb');

export default {
  name: 'app',
  components: {},
  data() {
    return {
    //players: data.players,
    //db_players: [],
    loaded: false
    }
  },   
  // firestore: {
  //   db_players: db.collection('players'),
  //   db_challenges: db.collection('challenges')
  // }, 
  //created() {
    // this unbinds any previously bound reference
    // this.$bind('players', db.collection('players')).then(players => {
    //  this.db_players === players      
      //this.$unbind('todos')
    //})   
  mounted (){    
    //this.$store.state.loading = true;
    //let otherPromises = [];
    //let arr2 = [];
  
    // Players
    // for (var y = 0; y < this.players.length; y++) {
    //   otherPromises.push(
    //     axios
    //       .get('https://api.cuescore.com/participant/?id=' + this.players[y])
    //       .then(res => {
    //         console.log(res.data);
    //         arr2.push(res.data);
    //       })
    //   )
    // }

    // Promise.all(otherPromises)
    //   .then(() => {
    //     this.$store.state.csPlayers = arr2;
    //   });

      
  },
}  
  
</script>

<style lang="css">
@import url("https://use.typekit.net/fnn6mon.css");

.overskrift {
  font-family: 'fnn6mon';
  color: grey;
  font-size:2em;
  margin-bottom:1em;
}

.header {
  font-family: 'fnn6mon';
  font-size: 2em;
  color: hsl(48, 100%, 67%);
  margin-left:1em;
  margin-right:2em;
}

.avsnitt-hi{
  margin-top:1em;
}

.avsnitt-low{
  margin-bottom:1em;
}

</style>


<style lang="scss">
@import "~bulma/sass/utilities/_all";

$size-1: 4rem;
$size-2: 4rem;
$size-3: 3rem;
$size-4: 2rem;
$size-5: 1.75rem;
$size-6: 1.5rem;
$size-7: 1rem;
$body-font-size: 1.2rem;

// Set your colors
$primary: #11753e;
$primary-light: findLightColor($primary);
$primary-dark: findDarkColor($primary);
$primary-invert: findColorInvert($primary);

// Lists and maps
$custom-colors: null !default;
$custom-shades: null !default;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: mergeColorMaps(
    (
        "white": (
            $white,
            $black,
        ),
        "black": (
            $black,
            $white,
        ),
        "light": (
            $light,
            $light-invert,
        ),
        "dark": (
            $dark,
            $dark-invert,
        ),
        "primary": (
            $primary,
            $primary-invert,
            $primary-light,
            $primary-dark,
        ),
        "link": (
            $link,
            $link-invert,
            $link-light,
            $link-dark,
        ),
        "info": (
            $info,
            $info-invert,
            $info-light,
            $info-dark,
        ),
        "success": (
            $success,
            $success-invert,
            $success-light,
            $success-dark,
        ),
        "warning": (
            $warning,
            $warning-invert,
            $warning-light,
            $warning-dark,
        ),
        "danger": (
            $danger,
            $danger-invert,
            $danger-light,
            $danger-dark,
        ),
    ),
    $custom-colors
);

// Links
//$link: $primary;
$link: #11753e;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

</style>

